<template>
  <div>
    <el-card class="maintenance-parent">
      <div>
        <h2>Past maintenance</h2>
        <ul class="ul-maintenance">
          <h3 v-if="currentMaintenanceHistory.length == 0">No history</h3>
          <li
            class="li-maintenance"
            v-for="pastMaintenance in this.currentMaintenanceHistory"
            :key="pastMaintenance.pastscheduleid"
          >
            <div class="flex-maintenance">
              <h4>{{ pastMaintenance.maintenancetitle }}</h4>

              <p
                class="p-maintenance"
                v-if="pastMaintenance.wasmissed == false"
              >
                <span style="font-weight: bold"> completed on: </span
                >{{ pastMaintenance.completeddate }}
              </p>
              <p class="p-maintenance" v-else>
                <span style="font-weight: bold"> Was due on: </span>
                {{ pastMaintenance.scheduleddate }}
              </p>
              <p
                class="p-maintenance align-right"
                v-if="
                  pastMaintenance.wasmissed == false &&
                  pastMaintenance.dayslate == 0
                "
              >
                On time
              </p>
              <p
                class="p-maintenance align-right"
                v-if="
                  pastMaintenance.wasmissed == false &&
                  pastMaintenance.dayslate != 0
                "
              >
                {{ pastMaintenance.dayslate }} days late
              </p>
              <p
                class="p-maintenance align-right"
                v-if="pastMaintenance.wasmissed == true"
              >
                Missed
              </p>
              <hr />
            </div>
          </li>
        </ul>
      </div>
      <div class="float-button-parent">
        <el-button
          style="background-color: #02746e; color: white"
          @click="closeRecurringHistory()"
        >
          Ok
        </el-button>
      </div>
    </el-card>
    <div class="overlay-back"></div>
  </div>
</template>

<script>
export default {
  props: {
    currentMaintenanceHistory: Array,
  },
  //     mounted(){
  //   if(this.displayRecurringHistory == true)
  //         {
  //           document.getElementById("overlay-back").style.display = "block"
  //         }
  //         else
  //         {
  //           document.getElementById("overlay-back").style.display = "none"
  //         }
  //     },
  methods: {
    closeRecurringHistory() {
      this.$emit("close-recurring-history");
    },
  },
};
</script>

<style scoped>
h2,
h3 {
  text-align: center;
}
h4 {
  display: inline-block;
  max-width: 180px;
  min-width: 180px;
  margin-left: 55px;
}
.maintenance-parent {
  max-width: 700px;
  min-width: 800px;
  margin: auto;
  color: rgb(102, 102, 102);
  position: absolute;
  z-index: 10;
  background-color: white;
  max-width: 800px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  max-height: 70%;
  overflow-y: scroll;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}

.ul-maintenance {
  padding: 0px;
}

.li-maintenance {
  color: rgb(102, 102, 102);
  list-style-type: none;
}

.li-maintenance:hover {
  background-color: rgb(242, 242, 242);
  color: black;
}

.p-maintenance {
  display: inline-block;
  margin-left: 55px;
  max-width: 180px;
  min-width: 180px;
}

.flex-maintenance {
  width: 100%;
}

.align-right {
  text-align: right;
}
.float-button-parent {
  position: sticky;
  bottom: 20px;
  text-align: center;
}
.overlay-back {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.6;
  filter: alpha(opacity=60);
  z-index: 5;
}

@media (min-width: 250px) and (max-width: 979px) {
  .maintenance-parent {
    min-width: 100%;
    max-width: 100%;
  }
  .p-maintenance {
    display: block;
  }

  h4 {
    display: block;
  }

  .align-right {
    text-align: left;
  }
}
</style>